var map = {
	"./icon/iconfont.css": "7xIN",
	"./icon/iconfont.eot": "41FU",
	"./icon/iconfont.svg": "xCPn",
	"./icon/iconfont.ttf": "gjvD",
	"./icon/iconfont.woff": "AmmJ",
	"./img/avatar.png": "zQrT",
	"./img/bg.jpg": "Lr6H",
	"./img/bot.png": "EpYu",
	"./img/close.svg": "mq5u",
	"./img/favicons.ico": "xpTL",
	"./img/kef.png": "SUYu",
	"./img/loading.gif": "JRsF",
	"./img/logo.png": "dLd/",
	"./img/logo@2x.png": "RNtg",
	"./img/rgkf.svg": "bL5z",
	"./img/send.svg": "VnBd",
	"./img/show.png": "gQKk",
	"./img/sq.png": "rWRm",
	"./img/发送icon.svg": "kSnR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1